import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { ICustomer } from "src/core/customers/api/customers.api";
import {
  ITerminology,
  sentenceCase
} from "src/library/utils";

/**
 * This function returns a reusable formated column definition for customer data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for customer data
 */
export const customerColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  column: Partial<Pick<DisplayColumnDef<TData>, "id" | "enableColumnFilter" | "meta">>,
  terminology: ITerminology
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: "customer",
    filterType: "string",
    header: `${sentenceCase(terminology.customer.singular.text)}`,
    cell: info => {
      if (info.getValue()) {
        const customer = info.getValue() as ICustomer;

        if (customer) {
          return `(${customer.accountNumber}) ${customer.name}`;
        }
      }

      return "-";
    },
    enableSorting: false,
    enableColumnFilter: true,
    enableResizing: true,
    minSize: 100,
    meta: {
      style: { align: "left" },
      filter: column.meta?.filter ? column.meta?.filter : {
        filterType: "string",
        minLength: 3
      }
    }
  } as DisplayColumnDef<TData>);
};
